import React, { useMemo } from 'react'
import ActivityLogsCarCommutingUpdateByStaffScene from './ActivityLogsCarCommutingUpdateByStaffScene'
import { useCustom } from '../../../../provider/context'
import queryString from 'query-string'
import { useQuery } from '@apollo/client'
import {ACTIVITY_LOGS_UPDATE_BY_STAFF2 } from '../ActivityLogsUpdateByStaff/ActivityLogsUpdateByStaffList/ActivityLogsUpdateByStaff.graphql'
import { ErrorComponent, ProgressSpinner } from '../../../../components'
import { onPageChange } from '../../../../libs'
import { Router } from 'react-router-dom'

const STAFF_APPROVE_UPDATE_DOCTOR_CAR_COMMUTING_SEARCH = [
  'STAFF_UPDATE_DOCTOR_CAR_COMMUTING',
]

const formatUserAutoComplete = (user) => ({
  ...user,
  fullNameEmail: `${user.lastname} ${user.firstname} (${user.email})`,
  fullName: `${user.lastname} ${user.firstname}`,
  fullNameKana: `${user.lastnameKana} ${user.firstnameKana}`,
})

const buildWhereCondition = (staffId, doctorId, details) => ({
  ...(staffId && { Staff: { id: staffId } }),
  ...(doctorId && { Doctor: { id: doctorId } }),
  ...(details && { details_in: [details] }),
  activity_in: STAFF_APPROVE_UPDATE_DOCTOR_CAR_COMMUTING_SEARCH,
})

const ActivityLogsCarCommutingUpdateByStaff = ({ history, location: { search } }) => {
  const [{ i18n }] = useCustom()
  const {
    page = 1,
    rowsPerPage = 20,
    orderBy = 'createdAt_DESC',
    staffId,
    doctorId,
    details,
  } = queryString.parse(search)

  const parsedPage = parseInt(page, 10)
  const parsedRowsPerPage = parseInt(rowsPerPage, 10)
  const first = parsedRowsPerPage > 0 ? parsedRowsPerPage : 20
  const skip = Math.max((parsedPage - 1) * first, 0)

  const variables = useMemo(() => ({
    first,
    skip,
    orderBy,
    where: buildWhereCondition(staffId, doctorId, details),
    extraWhere: {
      activity_in: STAFF_APPROVE_UPDATE_DOCTOR_CAR_COMMUTING_SEARCH,
    },
  }), [first, skip, orderBy, staffId, doctorId, details])

  const { loading, error, data } = useQuery(ACTIVITY_LOGS_UPDATE_BY_STAFF2, {
    variables,
    fetchPolicy: 'network-only',
  })

  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent error={error} />
  const {
    activityLogsConnection: {
      edges,
      aggregate: { count },
    },
    staffs = [],
    doctors = [],
  } = data

  const staffSearchFormat = staffs.map(formatUserAutoComplete)
  const doctorSearchFormat = doctors.map(formatUserAutoComplete)

  const onSearch = ({ staff, doctor, details: nextDetails }) => {
    history.push({
      pathname: Router.staffActivityLogsCarCommutingListUpdateByStaff,
      search: queryString.stringify({
        rowsPerPage,
        staffId: staff?.id,
        doctorId: doctor?.id,
        details: nextDetails || undefined,
      }),
    })
  }

  return <ActivityLogsCarCommutingUpdateByStaffScene
    i18n={i18n}
    edges={edges}
    count={count}
    page={parsedPage}
    staffId={staffId}
    doctorId={doctorId}
    details={details}
    onSearch={onSearch}
    staffs={staffSearchFormat}
    doctors={doctorSearchFormat}
    rowsPerPage={parsedRowsPerPage}
    onPageChange={onPageChange(history, search)}
  />
}

export default ActivityLogsCarCommutingUpdateByStaff
